import React from 'react';
import css from './index.module.scss';
import ServiceFooter from './ServiceFooter';
import SiteFooter from './SiteFooter';

export interface Props {
  hideBlandContent?: boolean;
}

const MerchantGlobalFooter: React.FC<Props & React.HTMLProps<{}>> = (props) => {
  const { hideBlandContent } = props;

  return (
    <footer className={css.MerchantGlobalFooter}>
      {!hideBlandContent && <ServiceFooter />}
      <SiteFooter />
    </footer>
  );
};

MerchantGlobalFooter.defaultProps = {
  hideBlandContent: true,
};

export default MerchantGlobalFooter;
